import React, { Component } from 'react';

class Buscador extends Component {
    constructor(props) {
        super(props);

        this.limpiarBusqueda = this.limpiarBusqueda.bind(this);
        this.onKeyPress = this.onKeyPress.bind(this);
        this.buscarProcesos = this.buscarProcesos.bind(this);
    }

    buscarProcesos(event) {
        let valorInput = event.target.value;

        this.props.buscarProcesos(this.props.procesos, valorInput);
    }

    limpiarBusqueda() {
        this.props.buscarProcesos(this.props.procesos, "");
    }


    onKeyPress (event) {
        let regExp = /[a-zA-Z0-9ñÑáéíóúÁÉÍÓÚ \s]/ig;

        if (!regExp.test(event.key)) {
            event.preventDefault();
        }
    }

    render() {
        const { inputBuscador } = this.props;

        return (
            <div className="row ConfiguracionProcesos__Buscador ModelosContables--overflowHidden">
                <div className="col-md-12 seccionSuperior__buscador ModelosContables--floatLeft">
                    <div className="AsientosContables--floatLeft seccionSuperior__iconoLupa"></div>

                    <div className="AsientosContables--floatLeft ConfiguracionProcesos__BuscadorInput">
                        <input id="buscarProceso"
                            name="buscarProceso"
                            value={inputBuscador}
                            className="textbox-rectangular form-control default-input top-separator-xxxs bottom-separator-xxs seccionSuperior__inputBuscador"
                            onChange={this.buscarProcesos}
                            onKeyDown={null}
                            onFocus={null}
                            onKeyPress={null/* this.onKeyPress */}
                            placeholder="Buscar por nombre o descripción" />
                    </div>
                </div>
                
                {inputBuscador?.length > 0 ?
                    <div className="seccionSuperior__botonBuscador ModelosContables--floatLeft ModelosContables--positionAbsolute">
                        <button type="button" className="btn-tag ConfiguracionProcesos__BotonBorrarBusqueda ConfiguracionProcesos__botonBorrarBuscador" onClick={this.limpiarBusqueda}>
                            <span className="ti-close span-closable" />
                        </button>
                    </div>
                :
                    null
                }
            </div>
        );
    }
};

export default Buscador